import React from 'react';
import PropTypes from 'prop-types';
import { emptyObject } from 'ui-components/default-props/empty';
import CancelAccountContent from './ss-account/cancel-account-content';
import CancelStampsAccountContent from './stamps/cancel-stamps-account-content';
import CancelSubscriptionViaSupportModal from './3PL-account/3PL-cancel-via-support-modal';
import { usePaymentAndSubscriptionPageContext } from '../../context/payment-and-subscription-page-context';
import { CANCEL_ACCOUNT_PAGE, CANCEL_ACCOUNT_VIA_SUPPORT, CANCEL_STAMPS_ACCOUNT_PAGE } from '../../constants';
import { ActiveClientProptype, InactiveClientProptype, PendingClientProptype } from '../../../clients-3pl/prop-types';

const componentMap = {
  [CANCEL_ACCOUNT_PAGE]: CancelAccountContent,
  [CANCEL_STAMPS_ACCOUNT_PAGE]: CancelStampsAccountContent,
  [CANCEL_ACCOUNT_VIA_SUPPORT]: CancelSubscriptionViaSupportModal,
};

const CancellationModalContainer = ({ clientData = emptyObject, onClose }) => {
  const { currentPage } = usePaymentAndSubscriptionPageContext();
  const ModalComponent = componentMap[currentPage] ?? CancelAccountContent;

  return <ModalComponent clientData={clientData} onClose={onClose} />;
};

CancellationModalContainer.propTypes = {
  clientData: PropTypes.shape({
    activeClients: PropTypes.arrayOf(ActiveClientProptype),
    inactiveClients: PropTypes.arrayOf(InactiveClientProptype),
    pendingClients: PropTypes.arrayOf(PendingClientProptype),
    errorFetchingClients: PropTypes.bool,
  }),
  onClose: PropTypes.func.isRequired,
};

export default CancellationModalContainer;
